<mat-tab-group mat-align-tabs="start">
    <mat-tab label="SMS SETTING">
        <div class="card">
            <div class="card-body">
                <app-common-sms-setting></app-common-sms-setting>
            </div>
        </div>
    </mat-tab>

    <mat-tab label="APP WALLET SETTING">
        <div class="card">
            <div class="card-body">
                <app-app-wallet-setting></app-app-wallet-setting>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>
